import React from 'react';
import { Route, Link, Redirect, BrowserRouter as Router, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as rb from 'react-bootstrap';

class SlideInContent extends React.Component {
    constructor(props) {
        super();
        this.state = {
            apiUrl: window.$apiUrl,
            AboutUsFormData: [],
            AboutUsGoFormData: [],
            SelectedAboutUs: false,
            ProjectType:16
        };
        this.toggleAbout = this.toggleAbout.bind(this);
        this.handleChangeAboutUs = this.handleChangeAboutUs.bind(this);
        this.toggleStoryHideAbout = this.toggleStoryHideAbout.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.aboutRef = React.createRef();

    }
    toggleAbout() {
        this.props.parentMethod();
    }
    toggleStoryHideAbout() {
        this.props.parentMethod();
    }
    handleClickOutside(event) {

        if (this.props.hideShow) {
            if (this.aboutRef && !this.aboutRef.current.contains(event.target)) {
                //this.props.toggleMenu(false);
                this.toggleAbout();
            }
        }
    }
    getAboutUs() {
        fetch(this.state.apiUrl + '/CommonAPI/GetAboutYEP', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            }
        })
            .then(res => res.json())
            .then((data) => {
                this.setState({ AboutUsFormData: data });
            })
            .catch(console.log);

        fetch(this.state.apiUrl + '/CommonAPI/GetAboutYEPGO', {
            method: 'POST',
            headers: {
                'token': process.env.REACT_APP_API_TOKEN,
                'Content-Type': 'application/json; charset=utf-8',
                'access-control-allow-origin': '*'
            }
        })
            .then(res => res.json())
            .then((dataGo) => {
                this.setState({ AboutUsGoFormData: dataGo });

            })
            .catch(console.log);
    }

    handleChangeAboutUs(bool) {
        this.setState({ SelectedAboutUs: bool, ProjectType: bool ? 17 : 16});
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        this.getAboutUs();
    }

    render() {
       
        let display_About = this.props.hideShow ? 0 : '-100%';
        let sticker_a = this.props.hideShow ? '385px' : 0;
        let sticker_b = this.props.hideShow ? '420px' : 0;
        let ProjectType = this.state.ProjectType;

        return (
            <div className="position-fixed h-100 slideIn-container d-flex justify-content-end" style={{ top: 0, right: display_About }}>
                <div className="position-absolute cursor_pointer stickerA" style={{ top: 0, right: sticker_a, zIndex: 5 }} onClick={this.toggleAbout}><img src="./images/Tape1.png" className="img-fluid" /></div>
                <div className="position-absolute cursor_pointer stickerB" style={{ bottom: 0, right: sticker_b, zIndex: 5 }} onClick={this.toggleAbout}><img src="./images/Tape2.png" className="img-fluid" /></div>
                <div className="slideIn-info h-100 d-flex justify-content-center align-items-md-center position-relative" style={{ top: 0, right: display_About }} ref={this.aboutRef}>
                    <div className="position-relative w-100 h-100">

                        <div className="btn-close position-absolute cursor_pointer" style={{ top: '8%', right: 0, zIndex: 3 }} onClick={this.toggleAbout}><img src="./images/slice/1.homepage/popup/close.png" className="img-fluid" /></div>
                        <div className="position-absolute cursor_pointer AboutUsTag" style={{ top: '16%', left: 0, transform: 'rotate(-5deg)', zIndex: 3 }} onClick={() => this.handleChangeAboutUs(false)}>
                            <div className="text-light font-weight-bold bg-primary text-center py-2" style={{ 'width': '200px' }}>
                                YEP
                            </div>
                        </div>
                        <div className="position-absolute cursor_pointer AboutUsTag" style={{ top: '16%', left: '150px', transform: 'rotate(-5deg)', zIndex: 3 }} onClick={() => this.handleChangeAboutUs(true)}>
                            <div className="text-light font-weight-bold bg_B30837 text-center py-2" style={{ 'width': '200px' }}>
                                YEPGO
                            </div>
                        </div>
                        {/* <img src="images/slice/1.homepage/popup/bg-paper1.png" className="img-fluid img-paper" /> */}
                        <div className="position-absolute slideIn-content" style={{ top: '15%', right: 0 }}>
                            <h4 className="color_113F70 font-Gotham-Bold">{!this.state.SelectedAboutUs ? this.state.AboutUsFormData.About_Title : this.state.AboutUsGoFormData.About_Title}</h4>
                            <p className="color_393939" style={{ whiteSpace: 'pre-line' }}>
                                {!this.state.SelectedAboutUs ? this.state.AboutUsFormData.About_Description : this.state.AboutUsGoFormData.About_Description}

                            </p>
                            <div className="d-flex flex-row btn-about-row text-center">
                                <Link as="a" to={`/stories?Project=${ProjectType}`} target="_blank" onClick={this.toggleStoryHideAbout} className="mr-3 w-50">VIEW OUR STORIES</Link>
                                <a href="#" target="_blank" onClick={this.toggleStoryHideAbout} className="w-50">YOUTH CORPS WEBSITE</a>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SlideInContent;

